import { supabase } from '@/lib/supabase'

export type RewardsBingxInvitedUser = {
  uid: number
  invitation_code: string | null
  register_time_ms: number | null
  direct_invitation: boolean
  deposit: boolean
  trade: boolean
  kyc_result: string | null
  commission_ratio: number | null
  linked_account_id: string | null
}

export type RewardsBingxInvitedUsersResponse = {
  ok: boolean
  items: RewardsBingxInvitedUser[]
  total_items: number
  linked_total: number
  elapsed_ms: number
}

export async function fetchRewardsBingxInvitedUsers(params?: {
  limit?: number
  pageSize?: number
  budgetMs?: number
}): Promise<RewardsBingxInvitedUsersResponse> {
  const { data, error } = await supabase.functions.invoke('rewards-bingx-invited-users', {
    body: {
      limit: params?.limit ?? 1000,
      pageSize: params?.pageSize ?? 200,
      budget: params?.budgetMs ?? 55_000,
    } as any,
  })
  if (error) throw error
  return (Array.isArray(data) ? (data as any)[0] : (data as any)) as RewardsBingxInvitedUsersResponse
}

